import styled from 'styled-components';

const A=styled.a`
    text-decoration:underline;
    color:${({theme})=> theme.palette.text.secondary};
`
export default A;